module.exports = __webpack_public_path__ + "bm.012b04b78dff697d63ab.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/4x3/bm.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/4x3/bm.svg
// module chunks = styles